import EnquiryForm from "@/components/EnquiryForm";
import { DEALER_BENEFITS } from "@/lib/siteData";

const steps = [
  { n: "01", t: "Submit your details", d: "Share your city, current business, and investment appetite." },
  { n: "02", t: "Discovery call", d: "A 30-minute call with our partnerships team to align on fit." },
  { n: "03", t: "Factory tour", d: "See the operation. Meet the team. Ask the hard questions." },
  { n: "04", t: "Sign & launch", d: "Territory allocation, showroom kit, launch marketing." },
];

const BecomeDealerPage = () => {
  return (
    <div data-testid="dealer-page">
      {/* Hero */}
      <section className="bg-ivory">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7 reveal">
            <div className="overline mb-5">Franchise · Dealership · Distribution</div>
            <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight font-light">
              Grow with a<br />
              <span className="italic text-teal">real factory</span> behind you.
            </h1>
          </div>
          <p className="lg:col-span-5 text-base md:text-lg text-black/70 leading-relaxed reveal">
            Modular furniture is one of the fastest-growing home & office categories in Tier II and Tier III India. We partner with focused, ambitious dealers — building the right network, one territory at a time.
          </p>
        </div>
      </section>

      {/* Benefits */}
      <section className="bg-offwhite py-20 md:py-28 border-y border-brandgray">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <div className="max-w-3xl mb-14 reveal">
            <div className="overline mb-4">What you get</div>
            <h2 className="font-display text-4xl md:text-5xl leading-[1.05] tracking-tight font-light">
              A partnership that<br />
              <span className="italic text-navy">respects your capital.</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {DEALER_BENEFITS.map((b, i) => (
              <div key={i} className="bg-white border-t-4 border-teal p-8 md:p-10 reveal" style={{ transitionDelay: `${i * 70}ms` }}>
                <div className="font-display text-2xl md:text-3xl leading-snug">{b.title}</div>
                <p className="mt-4 text-base text-black/70 leading-relaxed">{b.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="bg-ivory py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-5 md:px-10">
          <div className="max-w-3xl mb-14 reveal">
            <div className="overline mb-4">How it works</div>
            <h2 className="font-display text-4xl md:text-5xl leading-[1.05] tracking-tight font-light">
              Four steps<br />
              <span className="italic text-navy">to launch.</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8">
            {steps.map((s, i) => (
              <div key={i} className="reveal" style={{ transitionDelay: `${i * 60}ms` }}>
                <div className="font-display text-5xl text-coral leading-none">{s.n}</div>
                <div className="font-display text-xl md:text-2xl mt-4 leading-snug">{s.t}</div>
                <p className="mt-3 text-sm md:text-base text-black/70 leading-relaxed">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Form */}
      <section className="bg-navy py-20 md:py-28">
        <div className="max-w-5xl mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 text-white reveal">
            <div className="overline text-gold mb-4">Apply</div>
            <h2 className="font-display text-4xl md:text-5xl leading-[1.05] tracking-tight font-light">
              Ready to build your<br />
              <span className="italic text-gold">territory?</span>
            </h2>
            <p className="mt-6 text-white/75 text-base leading-relaxed max-w-md">
              Applications are reviewed weekly. Serious enquiries only — territory protection means we can't onboard everyone.
            </p>
          </div>
          <div className="lg:col-span-7 reveal">
            <EnquiryForm variant="dealer" title="Dealership Application" subtitle="Fill in the essentials. Our partnerships team will call within 2 working days." />
          </div>
        </div>
      </section>
    </div>
  );
};

export default BecomeDealerPage;
